import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Button from '../Button';
import Dialog from '../Dialog';
import DialogContent from '../DialogContent';
import DialogActions from '../DialogActions';

const S = {
  DialogContent: styled(DialogContent)`
    margin-bottom: 2.5rem;
  `,
};

const AlertDialog = ({
  children, open, onClose, ...otherProps
}) => (
  <Dialog open={open} onClose={onClose} {...otherProps}>
    <S.DialogContent>
      {children}
    </S.DialogContent>
    <DialogActions>
      <Button
        type="button"
        variant="outlined"
        onClick={onClose}
      >
        닫기
      </Button>
    </DialogActions>
  </Dialog>
);

AlertDialog.propTypes = {
  children: PropTypes.node.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
};

AlertDialog.defaultProps = {
  onClose: () => {},
};

export default AlertDialog;
